import { createContext } from 'react';
import { Usedlessondetails } from '@/models';

export const ActiveLessonContext = createContext<{
  lesson: Usedlessondetails | null;
  setLesson: any;
}>({ lesson: null, setLesson: () => {} }); //using any for user as it's server defined
